import type { ReactNode } from 'react';
import type { WalletWithdrawal } from './walletTypes';

export const formatRand = (value: string | number) =>
  `R ${parseFloat(String(value)).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const formatWalletBalance = (
  value?: string | number | null,
  currency = 'ZAR',
) => {
  if (value === null || value === undefined || value === '') return '-';
  const amount = parseFloat(String(value));
  if (!Number.isFinite(amount)) return '-';
  return currency === 'ZAR'
    ? formatRand(amount)
    : `${currency} ${amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
};

export const statusBadgeVariant = (status?: string | null) => {
  const normalized = String(status ?? '').toUpperCase();
  if (
    ['ACTIVE', 'COMPLETED', 'REDEEMED', 'CONFIRMED', 'SUCCESS', 'UNREDEEMED'].includes(
      normalized,
    )
  )
    return 'success';
  if (['FAILED', 'REJECTED', 'EXPIRED', 'CANCELLED', 'SUSPENDED'].includes(normalized))
    return 'destructive';
  if (
    [
      'PROCESSING',
      'INITIATED',
      'REQUEST_RECEIVED',
      'IN_PROGRESS',
      'OPS_REVIEW',
      'AUTHORISED',
      'CREATED',
    ].includes(normalized)
  )
    return 'warning';
  return 'outline';
};

export const formatWalletDate = (dateString?: string | null) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString();
};

/** Voucher code and PIN are never shown in full; the server masks them. */
export const renderMaskedWalletVoucherHints = (withdrawal: WalletWithdrawal) => {
  const hints: ReactNode[] = [];

  if (withdrawal.voucher_code_masked) {
    hints.push(
      <p key="code" className="mt-1 font-mono text-[11px] text-muted-foreground">
        Code: {withdrawal.voucher_code_masked}
      </p>,
    );
  } else if (withdrawal.voucher_code_available) {
    hints.push(
      <p key="code" className="mt-1 text-[11px] text-muted-foreground">
        Code captured, hidden
      </p>,
    );
  }

  if (withdrawal.voucher_pin_masked) {
    hints.push(
      <p key="pin" className="mt-1 font-mono text-[11px] text-muted-foreground">
        PIN: {withdrawal.voucher_pin_masked}
      </p>,
    );
  } else if (withdrawal.voucher_pin_available) {
    hints.push(
      <p key="pin" className="mt-1 text-[11px] text-muted-foreground">
        PIN captured, hidden
      </p>,
    );
  }

  return hints.length ? <>{hints}</> : null;
};
